module.exports = __webpack_public_path__ + "03_medium_gold.3250061e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_medium_gold.png
// module id = 0DHj
// module chunks = 0